import React, { Fragment } from 'react';
interface PageLayoutProps {
  title: string;
  /** Supporting subtitle shown below title */
  description?: string;
  /** Alias for description */
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  breadcrumbs?: Array<{
    label: string;
    href?: string;
  }>;
}
export function PageLayout({
  title,
  description,
  subtitle,
  actions,
  children,
  className = '',
  breadcrumbs
}: PageLayoutProps) {
  const displayDescription = description ?? subtitle;
  return <div className={`flex flex-col h-full min-h-0 ${className}`} data-id="element-638">
      {/* Header */}
      <div className="flex-shrink-0 px-6 py-5 border-b border-gray-100 bg-white" data-id="element-639">
        {breadcrumbs && breadcrumbs.length > 0 && <div className="flex items-center gap-1.5 mb-2" data-id="element-640">
            {breadcrumbs.map((crumb, i) => <Fragment key={i} data-id="element-641">
                {i > 0 && <span className="text-gray-300 text-xs" data-id="element-642">/</span>}
                <span className="text-xs text-gray-400" data-id="element-643">{crumb.label}</span>
              </Fragment>)}
          </div>}
        <div className="flex items-start justify-between gap-4" data-id="element-644">
          <div data-id="element-645">
            <h1 className="text-lg font-semibold text-gray-900" data-id="element-646">{title}</h1>
            {displayDescription && <p className="text-sm text-gray-500 mt-0.5" data-id="element-647">
                {displayDescription}
              </p>}
          </div>
          {actions && <div className="flex items-center gap-2 flex-shrink-0" data-id="element-648">
              {actions}
            </div>}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto px-6 py-6" data-id="element-649">{children}</div>
    </div>;
}